import React, {useState, useEffect} from 'react';
import {Checkbox, Flex, Form, Input, Select} from "antd";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import IntlMessage, {IntlMessageText} from "../../../../../../components/IntlMessage/IntlMessage";
import classes from "../../../Applications/application.module.css";
import {LANGUAGES} from "../constants/languages";
import {getAllProfessionalStandards} from "../../../../../../store/slices/ProfessionalStandardsSlice";

const Step1GeneralInfo = ({form, data, currentStep}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {profStandards} = useSelector(state => state.profStandardsList);

    const [isLearnOffline, setIsLearnOffline] = useState(data?.firstStep?.isLearnOffline || false);
    const [isLearnOnline, setIsLearnOnline] = useState(data?.firstStep?.isLearnOnline || false);
    const [isLearnMixed, setIsLearnMixed] = useState(data?.firstStep?.isLearnMixed || false);
    const [isAccreditationExist, setIsAccreditationExist] = useState(data?.firstStep?.isAccreditationExist || false);

    useEffect(() => {
        dispatch(getAllProfessionalStandards({page: 1, limit: 100}));
    }, [dispatch]);

    React.useEffect(() => {
        if (data) {
            setIsAccreditationExist(data.firstStep?.isAccreditationExist);
            setIsLearnOffline(data.firstStep?.isLearnOffline);
            setIsLearnOnline(data.firstStep?.isLearnOnline);
            setIsLearnMixed(data.firstStep?.isLearnMixed);
        }
    }, [data]);

    // Обновляем скрытые поля в форме при изменении чекбоксов
    React.useEffect(() => {
        form.setFieldsValue({
            isAccreditationExist,
            isLearnOffline,
            isLearnOnline,
            isLearnMixed
        });
    }, [isAccreditationExist, isLearnOffline, isLearnOnline, isLearnMixed, form]);

    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={"small"}>
            <Form.Item
                hidden
                name="isAccreditationExist"
            >
                <Input type="hidden"/>
            </Form.Item>
            <Form.Item
                hidden
                name="isLearnOffline"
            >
                <Input type="hidden"/>
            </Form.Item>
            <Form.Item
                hidden
                name="isLearnOnline"
            >
                <Input type="hidden"/>
            </Form.Item>
            <Form.Item
                hidden
                name="isLearnMixed"
            >
                <Input type="hidden"/>
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 0, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('licenceNumberTo')}
                initialValue={"KZ67LAA00019559"}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="licenceNumber"
            >
                <Input
                    rootClassName={classes.formInput}
                    placeholder={IntlMessageText.getText({id: "licenceNumberTo"})}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 0, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('amOpCreditNum')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="creditNum"
            >
                <Input
                    type={'number'}
                    rootClassName={classes.formInput}
                    placeholder={IntlMessageText.getText({id: "amOpCreditNum"})}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: currentStep === 0, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('levelOfNQF')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="levelOfNQF"
            >
                <Input
                    type={'number'}
                    rootClassName={classes.formInput}
                    placeholder={IntlMessageText.getText({id: "levelOfNQF"})}
                />
            </Form.Item>

            <Checkbox
                onChange={() => setIsAccreditationExist(!isAccreditationExist)}
                checked={isAccreditationExist}
            >
                <IntlMessage id={'isAccreditationExist'}/>
            </Checkbox>

            <Flex align={"center"} justify={"flex-start"} gap={"middle"}>
                <Checkbox
                    onChange={() => setIsLearnOffline(!isLearnOffline)}
                    checked={isLearnOffline}
                >
                    <IntlMessage id={'isLearnOffline'}/>
                </Checkbox>
                <Checkbox
                    onChange={() => setIsLearnOnline(!isLearnOnline)}
                    checked={isLearnOnline}
                >
                    <IntlMessage id={'isLearnOnline'}/>
                </Checkbox>
                <Checkbox
                    onChange={() => setIsLearnMixed(!isLearnMixed)}
                    checked={isLearnMixed}
                >
                    <IntlMessage id={'isLearnMixed'}/>
                </Checkbox>
            </Flex>

            <Form.Item
                rules={[{required: currentStep === 0, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('foundationPage.upperCardBlock.3.title')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="learnLanguages"
            >
                <Select
                    mode="multiple"
                    options={LANGUAGES.map(lang => ({
                        value: lang.rus,
                        label: lang.rus
                    }))}
                    placeholder={IntlMessageText.getText({id: "foundationPage.upperCardBlock.3.title"})}
                />
            </Form.Item>

            <Form.Item
                label={t('profStandards')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="professionalStandards"
            >
                <Select
                    mode="multiple"
                    options={profStandards.map(ps => ({
                        value: ps.id,
                        label: ps.nameRu + " (" +  ps.code + ")"
                    }))}
                    placeholder={IntlMessageText.getText({id: "profStandards"})}
                />
            </Form.Item>
        </Flex>
    );
};

export default Step1GeneralInfo;
